import { useLanguage } from '../contexts/LanguageContext';
import { Globe } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

export default function LanguageSelector() {
  const { locale, changeLanguage, languages } = useLanguage();

  return (
    <div className="flex items-center gap-1.5" data-testid="language-selector">
      <Globe className="w-4 h-4 text-muted-foreground hidden sm:block" />
      <Select value={locale} onValueChange={changeLanguage}>
        <SelectTrigger className="bg-transparent border-border text-foreground w-auto sm:w-28 h-8 text-xs sm:text-sm px-2 sm:px-3">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {Object.entries(languages).map(([code, name]) => (
            <SelectItem key={code} value={code}>{name}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
